import React from 'react';
import { Sparkles } from 'lucide-react';
import styles from '../../../styles/index.module.scss';

/**
 * 生成结果卡片：标题栏 + 内容 + 操作区
 */
export const ResultCard = ({ title = '生成结果', meta, extra, children, actions }) => {
    return (
        <div className={styles.resultCard}>
            <div className={styles.resultHeader}>
                <span className={styles.resultHeaderTitle}>
                    <Sparkles size={14} />
                    {title}
                </span>
                <span className={styles.resultHeaderMeta}>
                    {extra}
                    {meta && <span>{meta}</span>}
                </span>
            </div>
            <div className={styles.resultBody}>{children}</div>
            {actions}
        </div>
    );
};

export default ResultCard;
